import { Injectable, NgZone } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

import { PromptService } from '../../components/prompt/prompt.service';

import { WindowService } from '@core/services';
import { environment } from 'src/environments/environment';
import { TranslationPipe } from '../../features/translate/translation.pipe';
import { logErrorInSentry } from '../errors/response-error';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  loginDelay = 30 * 1000;

  constructor(
    private swUpdate: SwUpdate,
    private promptService: PromptService,
    private ngZone: NgZone,
    private translationPipe: TranslationPipe,
    private windowService: WindowService,
  ) {}

  subscribeToAppUpdates(): void {
    if (!environment.production) {
      console.log(`SERVICE WORKER UPDATE ENABLED: ${this.swUpdate.isEnabled}`);
    }

    this.checkForUpdateAfterAppStart();

    if (!this.swUpdate.isEnabled) {
      return;
    }

    if (!environment.production) {
      // eslint-disable-next-line no-console
      console.time();
    }

    this.swUpdate.versionUpdates.subscribe((event) => {
      if (event.type !== 'VERSION_READY') {
        return;
      }

      if (!environment.production) {
        // eslint-disable-next-line no-console
        console.timeEnd();
      }

      this.windowService.reload();
    });

    this.swUpdate.unrecoverable.subscribe((event) => {
      const promptText = this.translationPipe.transform('prompt_sw_unrecoverable');

      logErrorInSentry({ message: event.reason });
      this.promptService.showError(promptText, { duration: 60 });
    });

    this.swUpdate.checkForUpdate();
  }

  checkForUpdateAfterLogin(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();
    }
  }

  checkForUpdateAfterAppStart(): void {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        if (this.swUpdate.isEnabled) {
          this.swUpdate.checkForUpdate();
        }
      }, this.loginDelay);
    });
  }
}
